// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> amc-preferred-theme-preferred -> park-paloma
// Generated: 2026-10-08T20:10:21.815Z
// Counts: 1 design, 74 content, 41 slot group, 7 collection binding, 7 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "At Park Paloma in Phoenix, AZ, find your perfect retreat in spacious one or two-bedroom floor plans. Nestled amid vibrant local attractions, enjoy art at the Phoenix Art Museum, explore nature at the Desert Botanical Garden, or dive into culture at the nearby Heard Museum. Experience exceptional living surrounded by community highlights.",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span>See What's Right Outside Your Doorstep</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span>Apartment Living That Fits Your Phoenix Lifestyle</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_apartmentsync_javascript_id"
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to make <span data-type=\"field-token\" data-field=\"property_name\"></span> your new home? Start your application online to take the next step toward finding an apartment that fits your needs. Complete the application below to get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.site_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "the",
    "generatedValue": null,
    "mappedField": "custom_audioeye_site_hash"
  },
  "feeguide.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Fee Guide</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": "property_bedrooms_range"
  },
  "floorplanslist.starting_at": {
    "overrideType": "VALUE",
    "customValue": "<p>Starting at $1,499</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/lincoln-place-apartments-in-unit-laundry-loveland-co::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience the convenience of having in-unit laundry at Lincoln Place Apartments. Our Loveland, CO community offers modern living with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Loveland, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1><p>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.</p><h2><strong>Information We Collect</strong></h2><p>We collect information from visitors on our Web site through online requests including:</p><ul><li><p>Contact Requests</p></li><li><p>Schedule a Tour Requests</p></li></ul><p>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.</p><h2>How the Information is Used</h2><p>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. In addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.</p><h2><strong>Sharing of Personal Information</strong></h2><p>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.</p><h2><strong>Security</strong></h2><p>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p><h2><strong>Cookies</strong></h2><p>From time to time, we may send a \"cookie\" to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer's hard drive. A cookie can't read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.</p><h2><strong>Links to Outside Sites</strong></h2><p>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.</p><h2><strong>Removal from Our Mailing List</strong></h2><p>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.</p><h2><strong>Contacting Us</strong></h2><p>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in vibrant <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>, our residents celebrate the sense of community and comfort we offer. Dive into our reviews and see what else our satisfied tenants have to say about life at <span data-type=\"field-token\" data-field=\"property_name\"></span>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Park Paloma in Phoenix, AZ, every detail is crafted for your convenience and comfort. From stylish, fully renovated homes to inviting social spaces, our amenities—like a fitness center, serene courtyard, and 24/7 emergency maintenance—enhance your lifestyle. Elevate your living experience today; your new home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "At Park Paloma in sunny Phoenix, AZ, our thoughtfully designed one and two-bedroom floor plans cater to your every need. Whether you seek a cozy retreat or a spacious sanctuary, we have the perfect layout for you. Have questions? Contact our leasing team today for personalized assistance!",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span>At Park Paloma in vibrant Phoenix, AZ, our thoughtfully designed floor plans cater to every lifestyle. Choose from spacious one-bedroom retreats or expansive two-bedroom layouts, each crafted for comfort and convenience. Browse our available apartment homes today and uncover the perfect space that reflects your unique style and needs.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a closer look at Park Paloma. Browse photos of our one- and two-bedroom apartments, along with community spaces designed for comfort and connection. From the poolside area to pet-friendly amenities and shared gathering spaces, the gallery offers a snapshot of everyday life at Park Paloma.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p>At Park Paloma in Phoenix, AZ, find your perfect retreat in spacious one or two-bedroom floor plans. Nestled amid vibrant local attractions, enjoy art at the Phoenix Art Museum, explore nature at the Desert Botanical Garden, or dive into culture at the nearby Heard Museum. Experience exceptional living surrounded by community highlights.</p>",
    "generatedValue": null,
    "mappedField": "property_neighborhood_blurb"
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We welcome cats and dogs. Non‑refundable pet fee: $300 for one pet. Monthly pet rent: $45 for one pet, $80 for two pets.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Park Paloma is where comfort meets convenience in Phoenix. Our one- and two-bedroom apartments offer thoughtfully designed living spaces in a location that keeps you close to the city’s best dining, shopping, and entertainment. Whether you’re relaxing at home or heading out to explore the neighborhood, Park Paloma makes it easy to enjoy the balance of everyday ease and urban energy—right where you want to be.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "At Park Paloma in vibrant Phoenix, AZ, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Experience modern living surrounded by delightful amenities and a welcoming community. Curious about life here? Schedule a tour and read firsthand accounts from our residents who call Park Paloma home!",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "Welcome to Park Paloma in vibrant Phoenix, AZ! Our thoughtfully designed one and two-bedroom apartments offer spacious layouts to suit your lifestyle. Step into your future home today—take a virtual tour of our beautiful community and see why Park Paloma is the perfect place to thrive!",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_company_name\"></span> logo</p>"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> logo, <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/01a0cfe7-6b87-7245-81bd-fcadfacf4ad5.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two Labrador Retrievers playing on a sunny day in an open field."
      }
    }
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d1-36a2-706d-9b39-0d964fa032a3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Park Paloma apartment building exterior with a leasing center sign."
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d3-c4bd-7748-9c07-5e6625998d39.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A resort-style outdoor swimming pool with lounge chairs and umbrellas at a multifamily property."
      }
    }
  },
  "applynowhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d4-27d1-72e1-8dc1-6fa1de3b43c7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with sofa, coffee table, and access to balcony."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d1-36a2-706d-9b39-0d964fa032a3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Park Paloma apartment building exterior with a leasing center sign."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-a5d6-702b-87ad-bdd61fa7207c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances and a decorative tile backsplash."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-d03d-71fc-800a-a684fe9d7d26.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious lounge area with modern seating and a view of the fitness center."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-cfde-766f-a3c8-d3db1a7b94dd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Treadmill and free weights in a well-equipped fitness center."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d4-29f9-7782-8b98-96c756b26cce.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Furnished living and dining area with modern sofa, coffee table, and decor in a Park Paloma apartment"
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d4-1252-7649-aa77-c0db37bffeac.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d2-fa4f-730d-a9bd-ae22f560da10.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d4-29f9-7782-8b98-96c756b26cce.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d3-e575-7180-9763-5cf2e8c8372a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment buildings with a pool and mountain backdrop."
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d4-58ab-7639-b69a-9b1b3e1be6b2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Map showing the location of various landmarks and neighborhoods in Phoenix, Arizona."
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/01a0cfe1-da50-73e4-bcdc-daaaac95528a.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "High angle of happy young female in bikini swimming in pool with rubber ring during summer holidays on sunny day"
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/01a0cfe2-4a07-758a-8e37-21e271cb6e03.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Big black and small white dogs walking on a forest path."
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d1-36a2-706d-9b39-0d964fa032a3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Park Paloma apartment building exterior with a leasing center sign."
      }
    }
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-b6ea-721e-b331-7075cff024cb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment buildings with balconies and desert landscaping."
      }
    }
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/01a0cfeb-6e53-72af-a99b-caa098dc86a7.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Group of stylish friends enjoying indoor leisure time in Mexico City."
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-dd6e-704a-a0f0-e61dc248a3bf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two women chatting by the poolside, enjoying a sunny day outdoors."
      }
    }
  },
  "propertyoverview.slide_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d3-59d7-77e8-8a9e-10de6abb58aa.webp"
      }
    }
  },
  "propertyoverview.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-ca24-7674-9ecf-c9ed4859ed0f.webp"
      }
    }
  },
  "propertyoverview.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-c2dc-716c-af6c-b9823e2aed6c.webp"
      }
    }
  },
  "propertyoverview.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-ca24-7674-9ecf-c9ed4859ed0f.webp"
      }
    }
  },
  "propertyoverview.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-a06d-750a-81c6-df5fa72d6f67.webp"
      }
    }
  },
  "propertyoverview.slide_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d3-d03d-71fc-800a-a684fe9d7d26.webp"
      }
    }
  },
  "propertyoverview.slide_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d4-4886-7267-8dac-59783348b241.webp"
      }
    }
  },
  "propertyoverview.slide_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166801/019d02d4-27d1-72e1-8dc1-6fa1de3b43c7.webp"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d3-bae3-7268-b66a-c27e9a2d8fa6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Park Paloma Apartment Homes package lockers and courtyard entrance with a modern wooden gate."
      }
    }
  },
  "reviewshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d4-4886-7267-8dac-59783348b241.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern lounge area with comfortable seating, coffee tables, and a bar with stools."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d3-4f0c-75af-b2da-03052a601bb1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "View of a gated entrance with two potted palm trees flanking a walkway."
      }
    }
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d3-b81c-7781-bf93-3781b127f516.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment building with stucco exterior and tile roof."
      }
    }
  },
  "thankyouhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d3-b2a1-765e-b74a-f86726554d08.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior walkway with lush landscaping and balconies of apartment buildings."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166801/019d02d0-dede-71bc-8ccb-402a394ab42a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room and dining area with gray sofa, coffee table, and dining set."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": [
      "custom_f7f27755-ad27-41fe-9942-1f877d65c9e4",
      "custom_29ebf607-49bd-4fb9-9dcd-c6d7747a0f60",
      "custom_50804105-7dc7-4bc8-a789-7c5e5e4b0b38",
      "custom_97df3c8b-511a-4b61-8ab0-a11523eb0d4b",
      "custom_8845e652-8073-4dcc-a1ad-93dd362b83e2",
      "custom_a420a340-cbf4-46f9-b797-207ff9712528",
      "custom_c7d98390-11fb-4c79-828d-b24069f7bf6e",
      "custom_9cd1367c-0bf6-42c0-be9e-b043cc4105d9",
      "custom_9a28b1ba-131c-41e3-92fa-5d9e9aaf7361",
      "custom_ef478be1-c101-4a81-b475-c28b55d1c72c",
      "custom_160b2c8e-870b-48cc-819a-46b6c9603ec4",
      "custom_705e413d-c053-43a3-865e-4691bc59147e",
      "custom_8fb958ea-8564-4e65-a490-75be17af79cb",
      "custom_5865107b-1b0c-4139-8252-e57e7b569026",
      "custom_81291244-f967-4b12-9dfc-ec1e7a064986",
      "custom_9399f7df-df16-41fe-9f2f-d84ba6b81a7b",
      "custom_02cf8a1b-9b95-4a48-ae54-cfd3b9062637",
      "custom_9ba98d37-9dd4-408c-84a3-0823f595712c",
      "custom_03359920-9163-44e0-94b3-299b7427fde8",
      "custom_f1dea984-bf7d-4f65-b2aa-133dfa3471e5"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": [
      "custom_bbc660ea-6751-4902-8a4f-f34a43fc4b9b"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_bbc660ea-6751-4902-8a4f-f34a43fc4b9b",
      "custom_fd6e6b98-fc97-4fd5-9148-e0160acb81f3",
      "custom_4745285e-4fff-4b3d-aa24-c5168f0845c0",
      "custom_3527eb39-fc1d-4b0f-b1c4-fcfe6f0e2475",
      "custom_2e212a5a-5e5d-48c9-8e89-351d38e9b2f7",
      "custom_187bd62e-ef50-4d32-80a9-52e784b7ca66",
      "custom_a615e575-9676-403c-acc6-62d487d944cd",
      "custom_27449aea-c8d4-40fb-b494-9f0f53aed469",
      "custom_dc24259e-b4e0-4d94-8bb9-ada07bd65db8",
      "custom_688e3f29-e919-48e2-a76d-21551ee6dd26",
      "custom_06fa3f70-9520-40b8-ae4e-3fecddc80ecf",
      "custom_771ca944-5491-4dc6-9d73-dd4f0b5dbc51",
      "custom_ae1afa31-ee9e-42c8-ba29-10618014464b",
      "custom_4fcd2cc3-c7cd-4bcb-8986-e1285d46cd3f",
      "custom_edea8a28-30b4-4880-8304-1f7ee46d6c83",
      "custom_f12bbeb9-97b5-482d-a989-4cd7a5f61db3",
      "custom_8a34f582-9796-413e-b5b1-d627b7404121",
      "custom_ec80fa28-70bb-4287-845b-7ff4935ff8e3"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.apartment_amenities": {
    "limit": 25,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.community_amenities": {
    "limit": 27,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
